export default {
    allColumn: [],
    showColumn: {},
    columnDeleteId: '',
    pagination: {},
    searchQuery: "",
    }